import { c as _c } from "react/compiler-runtime";
export const BalanceTransferIcon = t0 => {
  const $ = _c(11);
  const {
    selected
  } = t0;
  const fillColor = selected ? "#EFFCF8" : "#008254";
  const t1 = selected ? "#008254" : "#EFFCF8";
  let t2;
  if ($[0] !== t1) {
    t2 = <rect x="0.214355" width="40" height="40" rx="20" fill={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  if ($[2] !== fillColor) {
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M11.2111 11.1255C10.9031 11.1255 10.6533 11.3753 10.6533 11.6834V13.549H23.5393V11.6834C23.5393 11.3753 23.2895 11.1255 22.9815 11.1255H11.2111ZM25.0393 11.6834C25.0393 10.5469 24.118 9.62555 22.9815 9.62555H11.2111C10.0746 9.62555 9.15332 10.5469 9.15332 11.6834V19.5302C9.15332 20.6667 10.0746 21.5881 11.2111 21.5881H12.986C13.4002 21.5881 13.736 21.2523 13.736 20.8381C13.736 20.4238 13.4002 20.0881 12.986 20.0881H11.2111C10.9031 20.0881 10.6533 19.8383 10.6533 19.5302V15.049H23.5393V15.8207C23.5393 16.2349 23.8751 16.5707 24.2893 16.5707C24.7035 16.5707 25.0393 16.2349 25.0393 15.8207V11.6834Z" fill={fillColor} />;
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M17.4472 19.912C17.1391 19.912 16.8894 20.1617 16.8894 20.4698V22.3354H29.7754V20.4698C29.7754 20.1617 29.5256 19.912 29.2175 19.912H17.4472ZM31.2754 20.4698C31.2754 19.3333 30.354 18.412 29.2175 18.412H17.4472C16.3107 18.412 15.3894 19.3333 15.3894 20.4698V28.3167C15.3894 29.4532 16.3107 30.3745 17.4472 30.3745H29.2175C30.354 30.3745 31.2754 29.4532 31.2754 28.3167V20.4698ZM29.7754 23.8354H16.8894V28.3167C16.8894 28.6248 17.1391 28.8745 17.4472 28.8745H29.2175C29.5256 28.8745 29.7754 28.6248 29.7754 28.3167V23.8354Z" fill={fillColor} />;
    t5 = <path fillRule="evenodd" clipRule="evenodd" d="M25.9414 11.832C25.9414 11.4178 26.2772 11.082 26.6914 11.082H28.164C28.6413 11.082 29.099 11.2716 29.4364 11.609C29.7739 11.9465 29.9635 12.4042 29.9635 12.8815L29.9635 14.8L29.9951 14.7684C30.2879 14.4755 30.7628 14.4755 31.0557 14.7684C31.3486 15.0613 31.3486 15.5362 31.0557 15.8291L29.7438 17.141C29.6032 17.2816 29.4124 17.3607 29.2135 17.3607C29.0146 17.3607 28.8238 17.2816 28.6832 17.141L27.3713 15.8291C27.0784 15.5362 27.0784 15.0613 27.3713 14.7684C27.6642 14.4755 28.139 14.4755 28.4319 14.7684L28.4635 14.8L28.4635 12.8815C28.4635 12.8815 28.4635 12.8815 28.4635 12.8815C28.4635 12.802 28.432 12.7259 28.3758 12.6697C28.3196 12.6135 28.2434 12.582 28.164 12.582H26.6914C26.2772 12.582 25.9414 12.2462 25.9414 11.832Z" fill={fillColor} />;
    $[2] = fillColor;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">{t2}{t3}{t4}{t5}</svg>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};